export default __webpack_public_path__ + "resources/icons/n221-c155.png";